import * as $runtime from "../runtime.js";
import * as Affjax from "../Affjax/index.js";
import * as Affjax$dRequestBody from "../Affjax.RequestBody/index.js";
import * as Affjax$dResponseFormat from "../Affjax.ResponseFormat/index.js";
import * as Affjax$dWeb from "../Affjax.Web/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dHTTP$dMethod from "../Data.HTTP.Method/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dRegex from "../Data.String.Regex/index.js";
import * as Data$dString$dRegex$dFlags from "../Data.String.Regex.Flags/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dNow from "../Effect.Now/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Partial from "../Partial/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dQuery from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic$dForm$dResult from "../Restaumatic.Form.Result/index.js";
import * as Restaumatic$dForm$dWidgets from "../Restaumatic.Form.Widgets/index.js";
import * as Restaumatic$dForm$dWidgets$dBootstrap from "../Restaumatic.Form.Widgets.Bootstrap/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic$dServices$dStorage$dLocalStorageNoFallback from "../Restaumatic.Services.Storage.LocalStorageNoFallback/index.js";
import * as Restaumatic$dSite$dRoutes from "../Restaumatic.Site.Routes/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular$dDom$dBrowser from "../Specular.Dom.Browser/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dDom$dWidget from "../Specular.Dom.Widget/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dFormField from "../Specular.FormField/index.js";
import * as Specular$dFormField$dExtra from "../Specular.FormField.Extra/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Type$dEquality from "../Type.Equality/index.js";
const hasErrorsWithId = {displayedErrors: v => Specular$dFormField.displayedErrors(v._1.field)};
const hasLabelWithId = {
  getLabel: v => {
    const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.Nothing);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  }
};
const dateTimeLocalField = /* #__PURE__ */ Restaumatic$dForm$dWidgets$dBootstrap.dateTimeLocalField({
  writeRefLike: v => {
    const $0 = v._1.field.editRef;
    return v$1 => {
      if (v$1.tag === "Valid") {
        const $1 = v$1._1.value;
        return $0._2(_old => $1);
      }
      return () => {};
    };
  },
  readRefLike: v => Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(v._1.field.editRef._1),
  touchRefLike: v => v._1.field.focusOutCallback()
})(hasErrorsWithId)(Restaumatic$dForm$dWidgets.asDateTimeMaybeDateTime)(Restaumatic$dForm$dWidgets$dBootstrap.labelString)(hasLabelWithId)(Restaumatic$dForm$dInternal.hasFieldIdWithId)()();
const isTextFieldWithId = {textInput: v => Restaumatic$dForm$dInternal.isTextFieldFormFieldStrin.textInput(v._1.field)};
const textField = /* #__PURE__ */ Restaumatic$dForm$dWidgets$dBootstrap.textField(hasErrorsWithId)(Restaumatic$dForm$dWidgets$dBootstrap.labelString)(isTextFieldWithId)(hasLabelWithId)(Restaumatic$dForm$dInternal.hasFieldIdWithId)()();
const textAreaField = /* #__PURE__ */ Restaumatic$dForm$dWidgets$dBootstrap.textAreaField(hasErrorsWithId)(Restaumatic$dForm$dWidgets$dBootstrap.labelString)(isTextFieldWithId)(hasLabelWithId)(Restaumatic$dForm$dInternal.hasFieldIdWithId)()();
const identity = x => x;
const length = /* #__PURE__ */ Data$dFoldable.foldlArray(c => v => 1 + c | 0)(0);
const monadFRP = {MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder};
const withDynamic_ = /* #__PURE__ */ Specular$dFRP$dReplaceable.withDynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)(monadFRP);
const queryFormFieldPartial = /* #__PURE__ */ Restaumatic$dForm$dQuery.queryFormFieldPartial(Type$dEquality.refl);
const query = /* #__PURE__ */ Restaumatic$dForm$dQuery.queryWith(/* #__PURE__ */ Restaumatic$dForm$dQuery.queryRecord(Restaumatic$dForm$dInternal.asRecordRecord)()(/* #__PURE__ */ Restaumatic$dForm$dQuery.queryRecordCons({
  reflectSymbol: () => "email"
})(/* #__PURE__ */ Restaumatic$dForm$dQuery.queryRecordCons({reflectSymbol: () => "fullName"})(/* #__PURE__ */ Restaumatic$dForm$dQuery.queryRecordCons({
  reflectSymbol: () => "info"
})(/* #__PURE__ */ Restaumatic$dForm$dQuery.queryRecordCons({reflectSymbol: () => "numPeople"})(/* #__PURE__ */ Restaumatic$dForm$dQuery.queryRecordCons({
  reflectSymbol: () => "phone"
})(/* #__PURE__ */ Restaumatic$dForm$dQuery.queryRecordCons({reflectSymbol: () => "reservationDate"})(/* #__PURE__ */ Restaumatic$dForm$dQuery.queryRecordCons({
  reflectSymbol: () => "restaurantSlug"
})(Restaumatic$dForm$dQuery.queryRecordNilTotal)(/* #__PURE__ */ Restaumatic$dForm$dQuery.queryFinalPartial(Type$dEquality.refl))()()()()())(queryFormFieldPartial)()()()()())(queryFormFieldPartial)()()()()())(queryFormFieldPartial)()()()()())(queryFormFieldPartial)()()()()())(queryFormFieldPartial)()()()()())(queryFormFieldPartial)()()()()()))(Restaumatic$dForm$dQuery.Strict);
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Effect$dAff.applicativeAff)(Data$dFoldable.foldableMaybe);
const newEvent = /* #__PURE__ */ Specular$dFRP$dBase.newEvent(Specular$dInternal$dRIO.monadEffectRIO);
const holdDyn = /* #__PURE__ */ Specular$dFRP$dBase.foldDyn(monadFRP)(x => v => x);
const formView = form => Specular$dInternal$dRIO.bindImpl(Effect$dNow.nowDateTime)(now => Specular$dInternal$dRIO.bindImpl(dateTimeLocalField({
  label: Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.reservation.form.reservation_date.label),
    {}
  ),
  min: Data$dMaybe.$Maybe("Just", now),
  field: Restaumatic$dForm$dInternal.$WithId({id: "reservationDate", field: form.reservationDate})
}))(() => Specular$dInternal$dRIO.bindImpl(textField({
  label: Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.reservation.form.num_people.label),
    {}
  ),
  field: Restaumatic$dForm$dInternal.$WithId({id: "numPeople", field: form.numPeople}),
  props: [Specular$dDom$dElement.attr("type")("number"), Specular$dDom$dElement.attr("min")("1")]
}))(() => Specular$dInternal$dRIO.bindImpl(textField({
  label: Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.reservation.form.phone.label), {}),
  field: Restaumatic$dForm$dInternal.$WithId({id: "phone", field: form.phone})
}))(() => Specular$dInternal$dRIO.bindImpl(textField({
  label: Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.reservation.form.email.label), {}),
  field: Restaumatic$dForm$dInternal.$WithId({id: "email", field: form.email})
}))(() => Specular$dInternal$dRIO.bindImpl(textField({
  label: Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.reservation.form.full_name.label),
    {}
  ),
  field: Restaumatic$dForm$dInternal.$WithId({id: "fullName", field: form.fullName})
}))(() => Specular$dInternal$dRIO.bindImpl(textAreaField({
  label: Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.reservation.form.user_notes.label),
    {}
  ),
  field: Restaumatic$dForm$dInternal.$WithId({id: "info", field: form.info})
}))(() => Specular$dDom$dElement.el("button")([Specular$dDom$dElement.attr("type")("submit"), Specular$dDom$dElement.class_("button"), Specular$dDom$dElement.onClick_(form.submit)])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
  Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.reservation.form.submit),
  {}
))))))))));
const initForm = dictMonadFRP => {
  const Monad0 = dictMonadFRP.MonadCleanup1().Monad0();
  const bind2 = Monad0.Bind1().bind;
  const MonadEffect0 = dictMonadFRP.MonadEffect0();
  const newPersistentFormFieldE = Specular$dFormField$dExtra.newPersistentFormFieldE(dictMonadFRP)(Foreign$dGeneric$dClass.stringDecode)(Foreign$dGeneric$dClass.stringEncode);
  const newPersistentFormField = Specular$dFormField$dExtra.newPersistentFormField(dictMonadFRP)(Foreign$dGeneric$dClass.stringDecode)(Foreign$dGeneric$dClass.stringEncode);
  const newFormField = Specular$dFormField.newFormField(dictMonadFRP);
  const $$new = Specular$dRef.new(MonadEffect0);
  const pure3 = Monad0.Applicative0().pure;
  const words = Data$dString$dRegex.split((() => {
    const $0 = Data$dString$dRegex.regex("\\s+")(Data$dString$dRegex$dFlags.noFlags);
    if ($0.tag === "Left") { return Partial._crashWith(Data$dShow.showStringImpl($0._1)); }
    if ($0.tag === "Right") { return $0._1; }
    $runtime.fail();
  })());
  const minTwoWordConversion = {
    fromInitial: identity,
    toFinal: x => {
      if (length(Data$dArray.filterImpl(v => v !== "", words(x))) >= 2) { return Data$dEither.$Either("Right", x); }
      return Data$dEither.$Either(
        "Left",
        [
          Restaumatic$dI18n._translate(
            Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.activerecord.errors.models.user.attributes.full_name.invalid),
            {}
          )
        ]
      );
    }
  };
  return bind2(Specular$dFRP$dBase.newEvent(MonadEffect0))(submit => bind2(MonadEffect0.liftEffect(Effect$dNow.nowDateTime))(now => {
    const positiveIntConversionErrs = {
      positiveIntError: Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.errors.messages.greater_than),
        {count: "0"}
      ),
      intError: Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.errors.messages.not_a_number), {})
    };
    const formState = {
      submitOccured: submit.event,
      remoteErrors: (() => {
        const n = Specular$dInternal$dIncremental.constant(Data$dMap$dInternal.Leaf);
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })()
    };
    return bind2(newPersistentFormFieldE(Restaumatic$dServices$dStorage$dLocalStorageNoFallback.localStorageNoFallback)("reservation:email")(Specular$dFormField.emailConversion(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.validations.invalid_email),
      {}
    )))(Specular$dFormField.fieldStateEmpty(formState))(""))(emailField => bind2(newPersistentFormFieldE(Restaumatic$dServices$dStorage$dLocalStorageNoFallback.localStorageNoFallback)("reservation:phone")(Specular$dFormField.phoneConversion(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.validations.invalid_phone),
      {}
    )))(Specular$dFormField.fieldStateEmpty(formState))(""))(phoneField => bind2(newPersistentFormFieldE(Restaumatic$dServices$dStorage$dLocalStorageNoFallback.localStorageNoFallback)("reservation:numPeople")(Specular$dFormField.positiveIntConversion(positiveIntConversionErrs))(Specular$dFormField.fieldStateEmpty(formState))(""))(numPeople => bind2(newPersistentFormField(Restaumatic$dServices$dStorage$dLocalStorageNoFallback.localStorageNoFallback)("reservation:fullName")(minTwoWordConversion)(Specular$dFormField.fieldStateEmpty(formState))(""))(fullName => bind2(newPersistentFormField(Restaumatic$dServices$dStorage$dLocalStorageNoFallback.localStorageNoFallback)("reservation:info")(Specular$dFormField.categoryConversion.identity)(Specular$dFormField.fieldStateEmpty(formState))(""))(info => bind2(newFormField((() => {
      const $0 = Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.validations.enter_date), {});
      return {
        fromInitial: Data$dMaybe.Just,
        toFinal: v => {
          if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
          if (v.tag === "Nothing") { return Data$dEither.$Either("Left", [$0]); }
          $runtime.fail();
        }
      };
    })())(Specular$dFormField.fieldStateEmpty(formState))(now))(reservationDate => bind2($$new(false))(success => pure3({
      email: emailField,
      phone: phoneField,
      numPeople,
      fullName,
      info,
      reservationDate,
      submit: submit.fire(),
      submitEvent: submit.event,
      success
    }))))))));
  }));
};
const displaySuccess = /* #__PURE__ */ Specular$dDom$dElement.el("div")([/* #__PURE__ */ Specular$dDom$dElement.class_("alert alert-success")])(/* #__PURE__ */ Specular$dInternal$dRIO.bindImpl(/* #__PURE__ */ Specular$dDom$dElement.el("span")([
  /* #__PURE__ */ Specular$dDom$dElement.class_("icon-ok icon-green"),
  /* #__PURE__ */ Specular$dDom$dElement.attr("aria-hidden")("true")
])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.rio(env => Specular$dDom$dBrowser.appendRawHtmlImpl("&nbsp;")(env.parent)))(() => Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
  Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.reservation.success_message),
  {}
)))));
const view = form => withDynamic_(form.success._1)(v => {
  if (v) { return displaySuccess; }
  return formView(form);
});
const control = dictMonadFRP => {
  const MonadCleanup1 = dictMonadFRP.MonadCleanup1();
  const Monad0 = MonadCleanup1.Monad0();
  const Bind1 = Monad0.Bind1();
  const initForm1 = initForm(dictMonadFRP);
  const subscribeEvent_ = Specular$dFRP$dBase.subscribeNode(dictMonadFRP.MonadEffect0())(MonadCleanup1);
  const pure3 = Monad0.Applicative0().pure;
  return dynRestaurantSlug => Bind1.bind(initForm1)(form => Bind1.bind(subscribeEvent_(v => {
    const $0 = Effect$dAff._makeFiber(
      Effect$dAff.ffiUtil,
      Effect$dAff._bind(Specular$dFRP$dBase.readDynamic(Effect$dAff.monadEffectAff)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toMaybeLax)(query({
        restaurantSlug: Restaumatic$dForm$dFinal.makeFinal(dynRestaurantSlug),
        ...form
      }))))(v1 => for_(v1)(request => Effect$dAff._bind(Effect$dAff._liftEffect(Restaumatic$dSite$dRoutes.reservationPath))(path => Effect$dAff._bind(Affjax.request(Affjax$dWeb.driver)({
        ...Affjax.defaultRequest,
        method: Data$dEither.$Either("Left", Data$dHTTP$dMethod.POST),
        url: path,
        content: Data$dMaybe.$Maybe(
          "Just",
          Affjax$dRequestBody.$RequestBody(
            "FormURLEncoded",
            Data$dFunctor.arrayMap(Data$dTuple.functorTuple.map(Data$dMaybe.Just))([
              Data$dTuple.$Tuple("table_reservation[restaurant_slug]", request.restaurantSlug),
              Data$dTuple.$Tuple("table_reservation[reservation_date]", DateUtils.formatISODateTime(request.reservationDate)),
              Data$dTuple.$Tuple("table_reservation[num_people]", Data$dShow.showIntImpl(request.numPeople)),
              Data$dTuple.$Tuple("table_reservation[full_name]", request.fullName),
              Data$dTuple.$Tuple("table_reservation[email]", request.email),
              Data$dTuple.$Tuple("table_reservation[phone]", request.phone),
              Data$dTuple.$Tuple("table_reservation[info]", request.info)
            ])
          )
        ),
        responseFormat: Affjax$dResponseFormat.$ResponseFormat("Json", Affjax$dResponseFormat.identity)
      }))(response => {
        const $0 = (() => {
          if (response.tag === "Right") { return response._1.status >= 200 && response._1.status < 300; }
          if (response.tag === "Left") { return false; }
          $runtime.fail();
        })();
        return Effect$dAff._liftEffect(form.success._2(_old => $0));
      }))))
    );
    return () => {
      const fiber = $0();
      fiber.run();
    };
  })(form.submitEvent))(() => pure3(form)));
};
const control1 = /* #__PURE__ */ control(monadFRP);
const run = cfg => {
  const $0 = Specular$dDom$dWidget.runWidgetInNode(cfg.container)(Specular$dInternal$dRIO.bindImpl(newEvent)(e => Specular$dInternal$dRIO.bindImpl(holdDyn(Data$dMaybe.Nothing)(Specular$dFRP$dBase.functorEvent.map(Data$dMaybe.Just)(e.event)))(dyn => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.bindImpl(control1(dyn))(view))(() => Specular$dInternal$dRIO.pureImpl({
    selectedRestaurantSlug: e.fire
  })))));
  return () => {
    const a$p = $0();
    return a$p._1;
  };
};
export {
  control,
  control1,
  dateTimeLocalField,
  displaySuccess,
  for_,
  formView,
  hasErrorsWithId,
  hasLabelWithId,
  holdDyn,
  identity,
  initForm,
  isTextFieldWithId,
  length,
  monadFRP,
  newEvent,
  query,
  queryFormFieldPartial,
  run,
  textAreaField,
  textField,
  view,
  withDynamic_
};
